import React, { useEffect, useRef, useState } from "react";
import Table from "./Table";
import NavBar from "components/SideBar/SideBar2";
import "../style.css";
import Header from "./Header";
import SubHeader from "./SubHeader";
import {
  getGstinList,
  getNoticeTableData,
  setGstinList,
  setNoticeTableData,
  setSearch,
  setSelectedDate,
  setSelectedGstin,
  getFetchHistory,
  getEntityList,
  fetchNoticesBulk,
  setSelectedEntity,
} from "./action";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { RingLoader } from "react-spinners";
import { formatDateToDDMMYYYY, headerColumns } from "../Utility/utilis";
import { errorToastMessage } from "utils/errorToast";
import { COMMON_MSGS } from "Constant/Messages";
import TableHeader from "../Utility/TableHeader";
import History from "./History";

export default function Notices(props) {
  const dispatch = useDispatch();
  const interval = useRef("");
  const {
    loaderStatus,
    selectedDate,
    selectedGstin,
    selectedFromPeriod,
    selectedToPeriod,
    selectedIssueDate,
    selectedDueDate,
    noticeTypeCodeFilterList,
    referenceIdFilterList,
    search
  } = useSelector((state) => state.noticeReducer);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageNoHistory, setPageNoHistory] = useState(1);
  const [activeTab, setActiveTab] = useState(1);

  const getTableData = async (pageNo, searchStr, searchMsg = true) => {
    try {
      if (!selectedGstin || selectedGstin.length === 0) {
        if (searchMsg) errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
        return;
      }
      const formattedDate = formatDateToDDMMYYYY(selectedDate);
      const filters = {
        mode: "note",
        gstin: selectedGstin,
        periodMonth: formattedDate,
        page: pageNo,
        pageSize: 10,
        q: searchStr || "",
        fromPeriod: selectedFromPeriod,
        toPeriod: selectedToPeriod,
        issueDate: selectedIssueDate,
        dueDate: selectedDueDate,
        refId:referenceIdFilterList,
        noticeType:noticeTypeCodeFilterList
      };
      dispatch(getNoticeTableData(filters));
    } catch (error) {
      console.log("Error in getTableData: ", error);
    }
  };

  const handlePageClick = (value) => {
    const newPage = value.selected + 1;
    setPageNumber(newPage);
    getTableData(newPage,search);
  };

  const handlePageClickHistory = (value) => {
    const newPage = value.selected + 1;
    setPageNoHistory(newPage);
    fetchHistory(false,newPage);
  }
  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);

    // Handle interval management based on tab change
    if (tabIndex === 2) {
      // Stop interval when switching to tab 2
      if (interval.current) {
        clearInterval(interval.current);
        interval.current = null;
        console.log("Interval stopped - switched to tab 2");
      }
    } else if (tabIndex === 1) {
      // Check for in-progress files when switching back to tab 1
      checkAndStartInterval();
    }
  };

  const checkAndStartInterval = async () => {
    try {
      // Clear any existing interval first
      if (interval.current) {
        clearInterval(interval.current);
        interval.current = null;
      }

      // Fetch current history data
      const fileDataTemp = await dispatch(getFetchHistory());
      const inProcessStatusCount = countInProcessFiles(fileDataTemp);

      // Start interval only if there are files in progress
      if (fileDataTemp?.length > 0 && inProcessStatusCount > 0) {
        console.log(
          `Starting interval - ${inProcessStatusCount} files in progress`
        );

        interval.current = setInterval(async () => {
          try {
            const updatedFileData = await dispatch(getFetchHistory());
            const updatedInProcessCount = countInProcessFiles(updatedFileData);

            if (updatedInProcessCount === 0) {
              clearInterval(interval.current);
              interval.current = null;
              console.log("All files processed - interval stopped");
            }
          } catch (error) {
            console.error("Polling error:", error);
            clearInterval(interval.current);
            interval.current = null;
          }
        }, 10000);
      } else {
        console.log("No files in progress - interval not started");
      }
    } catch (error) {
      console.error("Error checking file status:", error);
    }
  };

  const countInProcessFiles = (files) =>
    files?.filter(
      (item) => !["COMPLETED", "FAILED"].includes(item?.STATUS?.toUpperCase())
    )?.length || 0;

  const getInProcessFileIds = (files) =>
    files
      ?.filter(
        (item) =>
          !["COMPLETED", "FAILED"].includes(
            item?.STATUS?.toUpperCase()
          )
      )
      .map((item) => item?.ID) || [];

  const fetchHistory = async (toastMsg = false,pageNo) => {
    try {
      // Clear any previous interval
      if (interval.current) {
        clearInterval(interval.current);
        interval.current = null;
      }

      // Initial fetch
      const formattedDate = formatDateToDDMMYYYY(selectedDate);
      let fileDataTemp = await dispatch(getFetchHistory(toastMsg,pageNo));
      let inProcessStatusCount = countInProcessFiles(fileDataTemp);
      let inProcessFileIds = getInProcessFileIds(fileDataTemp);
      
      // Console log IN-PROGRESS files info
      console.log('IN-PROGRESS files count:', inProcessStatusCount);
      console.log('IN-PROGRESS file IDs:', inProcessFileIds);
      
      // Only start interval if we're on tab 1 and there are files in progress
      if (
        activeTab === 1 &&
        fileDataTemp?.length > 0 &&
        inProcessStatusCount > 0
      ) {
        interval.current = setInterval(async () => {
          try {
            // Fetch updated history
            fileDataTemp = await dispatch(getFetchHistory(toastMsg,pageNo));
            inProcessStatusCount = countInProcessFiles(fileDataTemp);
            inProcessFileIds = getInProcessFileIds(fileDataTemp);
            
            // Console log updated IN-PROGRESS files info during interval
            console.log('IN-PROGRESS files count (interval):', inProcessStatusCount);
            console.log('IN-PROGRESS file IDs (interval):', inProcessFileIds);

            if (inProcessStatusCount === 0) {
              clearInterval(interval.current);
              interval.current = null;
              console.log("All files processed.");
            }
          } catch (error) {
            console.error("Polling error:", error);
            clearInterval(interval.current);
            interval.current = null;
          }
        }, 10000);
      }
    } catch (error) {
      console.error("Error fetching history data:", error);
      // errorToastMessage("error in fetching history data");
    }
  };

  useEffect(() => {
    fetchHistory(false);
    dispatch(getEntityList());
    return () => {
      if (interval.current) {
        clearInterval(interval.current);
        interval.current = null;
      }
    };
  }, []);

  useEffect(() => {
    return () => {
      setPageNumber(1);
      setPageNoHistory(1);
      dispatch(setSelectedGstin(""));
      dispatch(setSelectedDate(""));
      dispatch(setGstinList([]));
      dispatch(setSelectedEntity(""));
      dispatch(setSearch(""));
      dispatch(setNoticeTableData([]));
    };
  }, []);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable
        pauseOnHover
      />
      <div className="sweet-loading">
        <RingLoader size={100} color={"#123abc"} loading={loaderStatus} />
      </div>
      <NavBar
        currentPage="Notice | Notice"
        module="notice"
        history={props.history}
      >
        <Header
          getTableData={getTableData}
          activeTab={activeTab}
          fetchHistory={fetchHistory}
          setPageNoHistory={setPageNoHistory}
        />

        <div
          style={{
            display: "flex",
            height: "3em",
            boxShadow: "0px 2px 3px 0px #8080805e",
            paddingRight: "5px",
          }}
        >
          <TableHeader
            handleTabChange={handleTabChange}
            columns={headerColumns}
            activeTab={activeTab}
          />
        </div>
        {activeTab === 2 && (
          <SubHeader
            setPageNumber={setPageNumber}
            getTableData={getTableData}
          />
        )}
        {activeTab === 2 && (
          <Table pageNumber={pageNumber} handlePageClick={handlePageClick} />
        )}
        {activeTab === 1 && <History pageNoHistory={pageNoHistory} handlePageClickHistory={handlePageClickHistory} setPageNoHistory={setPageNoHistory} />}
      </NavBar>
    </>
  );
}
